jQuery(function ($) {
  // Custom Script Starts

  // Custom Script Ends
});


// document.querySelectorAll('.spice-spa-addon-product-link').forEach(link => {
//     link.addEventListener('click', function(event) {
//         // 1. Stop the link from opening the URL
//         event.preventDefault();
        
//         // 2. Find the product ID from the checkbox in the same section
//         const container = this.closest('.spice-spa-addon-item, .spice-spa-addon-product-item, div:has(> .spice-spa-addon-right)');
//         const checkbox = container ? container.querySelector('input.spice-spa-addon-checkbox-input') : null;
        
//         if (checkbox && checkbox.value) {
//             const productId = checkbox.value;
            
//             // 3. Open the popup
//             if (typeof SPICEADDONS !== 'undefined' && typeof SPICEADDONS.generateModelbox === 'function') {
//                 SPICEADDONS.generateModelbox(productId);
//             }
//         }
//     });
// });

// document.body.addEventListener('click', function(event) {
//   // Check if the clicked element (or its parent) is the product link
//   const link = event.target.closest('.spice-spa-addon-product-link');
  
//   if (link) {
//     // 1. Prevent the page from navigating
//     event.preventDefault();
//     event.stopPropagation();
    
//     // 2. Find the product item container
//     const productItem = link.closest('.spice-spa-addon-product-item');
    
//     // 3. Find the "Quick View" button inside that container
//     const quickViewBtn = productItem ? productItem.querySelector('.spice-spa-addon-product-quick-view') : null;
    
//     if (quickViewBtn) {
//       // 4. Trigger the click on the button that already has the modal logic
//       quickViewBtn.click();
//     }
//   }
// }, true); // The 'true' here is important for intercepting the event early

// function syncCenterWidths() {
//   const topCenter = document.querySelector('.header__row--top .header__column--center');
//   const bottomCenter = document.querySelector('.header__row--bottom .header__column--center');

//   if (topCenter && bottomCenter) {
//     const width = bottomCenter.offsetWidth;
//     topCenter.style.width = `${width}px`;
//   }
// }



// document.querySelectorAll('.slick-track').forEach(track => {
//   const slides = track.querySelectorAll('.slick-slide');

//   if (slides.length > 3) {
//     track.closest('.slick-list')?.classList.add('show-slide');
//   }
// });

function syncFilterHeadingHeight() {
  const applyHeight = () => {
    const actionsEl = document.querySelector(".gf-actions");
    const headingEl = document.querySelector(".gf-filter-desktop-heading");

    if (!actionsEl || !headingEl) return false;

    const exactHeight = actionsEl.getBoundingClientRect().height;
    
    const filterTitleHeight = Math.round(exactHeight * 100) / 100;
console.log(filterTitleHeight, 'filterTitleHeight');
    headingEl.style.height = `${filterTitleHeight}px`;

    return true;
  };

  // Run immediately if elements already exist
  if (applyHeight()) return;

  // Watch for AJAX-rendered content
  const observer = new MutationObserver(() => {
    if (applyHeight()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Initialize
syncFilterHeadingHeight();

// document.addEventListener('submit', async function (e) {
//     const form = e.target;

//     if (!form.classList.contains('quick-add-form')) {
//         return;
//     }

//     // Ignore PDP
//     if (window.location.pathname.indexOf('/products/') === 0) {
//         return;
//     }

//     e.preventDefault();

//     const submitBtn = form.querySelector('[type="submit"]');

//     if (submitBtn?.disabled) {
//         return;
//     }

//     submitBtn.disabled = true;

//     const loader = document.getElementById('plp-cart-loader');

//     if (loader) {
//         loader.classList.add('active');
//     }

//     try {
//         const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             body: new FormData(form),
//             headers: {
//                 'Accept': 'application/json'
//             }
//         });

//         if (!response.ok) {
//             throw new Error(`HTTP ${response.status}`);
//         }

//         window.location.reload();

//     } catch (error) {
//         console.error(error);

//         submitBtn.disabled = false;

//         if (loader) {
//             loader.classList.remove('active');
//         }
//     }
// }, true);

// const topCenter = document.querySelector(
//   '.header__row--top .header__column--center'
// );

// function updateWidth() {
//   document.documentElement.style.setProperty(
//     '--header-center-width',
//     `${topCenter.offsetWidth}px`
//   );
// }

// updateWidth();
// new ResizeObserver(updateWidth).observe(topCenter);

// document.addEventListener('DOMContentLoaded', () => {
//   const topCenter = document.querySelector(
//     '.header__row--top .header__column--center'
//   );

//   const bottomCenter = document.querySelector(
//     '.header__row--bottom .header__column--center'
//   );

//   if (!topCenter || !bottomCenter) return;

//   const syncWidth = () => {
//     const width = bottomCenter.getBoundingClientRect().width;
//     topCenter.style.width = `${width}px`;
//   };

//   // Initial sync
//   syncWidth();

//   // Re-sync when bottom center changes size
//   new ResizeObserver(syncWidth).observe(bottomCenter);

//   // Re-sync on window resize
//   window.addEventListener('resize', syncWidth);
// });

// const topColumns = document.querySelector(
//   '.header__row--top .header__columns'
// );

// topColumns.style.gridTemplateColumns = `1fr ${width}px 1fr`;

// document.addEventListener('DOMContentLoaded', () => {
//   const topColumns = document.querySelector('.header__row--top .header__columns');
//   const bottomCenter = document.querySelector(
//     '.header__row--bottom .header__column--center'
//   );

//   if (!topColumns || !bottomCenter) return;

//   const syncWidth = () => {
//     const width = bottomCenter.getBoundingClientRect().width;
// console.log('width', width);
//     // Ignore initial 0 width
//     if (width > 0) {
//       topColumns.style.gridTemplateColumns = `1fr ${width}px 1fr`;
//     }
//   };

//   // Delay initial calculation slightly
//   setTimeout(syncWidth, 100);

//   // Watch for dynamic changes
//   new ResizeObserver(syncWidth).observe(bottomCenter);

//   window.addEventListener('resize', syncWidth);
// });

// setTimeout(syncWidth, 200);

// console.log('Bottom width:', bottomCenter.getBoundingClientRect().width);

window.addEventListener('load', function() {
    const wishlistButtons = document.querySelectorAll('wishlist-button-block');
    wishlistButtons.forEach(button => {
        button.style.setProperty('display', 'inline-block', 'important');
    });
});

// document.addEventListener('cart:update', async () => {
//   // const loader = document.getElementById('plp-cart-loader');

//   // if (loader) {
//   //   loader.classList.add('active');
//   // }

//   try {
//     const response = await fetch('/cart.js', {
//       headers: {
//         'Accept': 'application/json'
//       }
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP ${response.status}`);
//     }

//     const cart = await response.json();

//     const bubble = document.querySelector('#custom-cart-bubble');
//     const cartIcon = document.querySelector('.custom-cart-icon');

//     if (bubble) {
//       bubble.innerHTML = cart.item_count > 0
//         ? `
//           <span class="cart-bubble">
//             <span class="cart-bubble__text">
//               ${cart.item_count}
//             </span>
//           </span>
//         `
//         : '';
//     }

//     if (cartIcon) {
//       cartIcon.classList.toggle(
//         'has-items',
//         cart.item_count > 0
//       );
//     }

//   } catch (error) {
//     console.error('Cart update failed:', error);

//   } finally {
//     document.querySelectorAll('.quick-add-btn.is-loading').forEach(function (button) {
//       button.classList.remove('is-loading');
//     });
//   }
// });

// document.addEventListener('submit', function (e) {
//   const form = e.target;

//   if (!form.matches('[data-type="add-to-cart-form"]')) {
//     return;
//   }

//   const button = form.querySelector('.quick-add-btn');

//   if (button) {
//     button.classList.add('is-loading');
//   }
// });


/*PLP page ATC*/
// document.addEventListener('submit', async function (e) {
//   const form = e.target;

//   if (!form.matches('.quick-add-form')) return;

//   e.preventDefault();

//   const button = form.querySelector('.quick-add-btn');

//   if (!button) return;

//   button.classList.add('is-loading');

//   try {
//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       body: new FormData(form)
//     });

//     if (!response.ok) {
//       throw new Error('Add to cart failed');
//     }

//     document.dispatchEvent(new CustomEvent('cart:update'));

//   } catch (error) {
//     console.error(error);
//   } finally {
//     // setTimeout(() => {
//     //   button.classList.remove('is-loading');
//     // }, 1000);
//   }
// });

// Listener that accepts cart data directly from the event payload
document.addEventListener('cart:update', (e) => {
  const cart = e.detail?.cart;
  if (!cart) return;

  const bubble = document.querySelector('#custom-cart-bubble');
  const cartIcon = document.querySelector('.custom-cart-icon');

  if (bubble) {
    bubble.innerHTML = cart.item_count > 0
      ? `<span class="cart-bubble"><span class="cart-bubble__text">${cart.item_count}</span></span>`
      : '';
  }

  if (cartIcon) {
    cartIcon.classList.toggle('has-items', cart.item_count > 0);
  }
});

// Consolidated submit handler
document.addEventListener('submit', async function (e) {
  const form = e.target;
  if (!form.matches('.quick-add-form, [data-type="add-to-cart-form"]')) return;

  e.preventDefault();
  const button = form.querySelector('.quick-add-btn');

  if (button?.classList.contains('is-loading')) return;
  if (button) button.classList.add('is-loading');

  try {
    // POST the item to cart
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    });

    if (!addResponse.ok) throw new Error('Add to cart failed');

    // Fetch the full updated cart once right here
    const cartResponse = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });
    const updatedCart = await cartResponse.json();

    // Pass the fetched cart object in the event detail so cart:update doesn't need to fetch again
    document.dispatchEvent(new CustomEvent('cart:update', { 
      detail: { cart: updatedCart } 
    }));

  } catch (error) {
    console.error('Add to cart error:', error);
  } finally {
    if (button) button.classList.remove('is-loading');
  }
});